// 导出 对应的不同接口的URL地址
module.exports = {
    domain: {
        Base_API_JSON: '', //模块一接口地址
        // Base_API_DEV: 'http://dev.chengyitek.cn/pc/ciit_rd/public/?s=', //模块二接口地址
        Base_API_DEV: process.env.VUE_APP_BASE_API, //模块二接口地址
    }
}
